import { TicketCategory, TicketCategoryEntry } from '../type/ticket-category'
import { TicketCategoryDto } from '../type/ticket-category.dto'

export const ticketCategoryEntityToEntry = (entity: TicketCategory): TicketCategoryEntry => {
  return {
    id: entity.id,
    title: entity.title,
    key: entity.id.toString(),
  } as TicketCategoryEntry
}

export const ticketCategoryEntryToDto = (entry: TicketCategoryEntry): TicketCategoryDto => {
  return {
    title: entry.title
  }
}

